import React from "react";
import "./App.css";
import "./styles/sisaline.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import ChiSiamo from "./pages/ChiSiamo";
import Servizi from "./pages/Servizi";
import Prodotti from "./pages/Prodotti";
import ComeLavoriamo from "./pages/ComeLavoriamo";
import Galleria from "./pages/Galleria";
import Contatti from "./pages/Contatti";
import Admin from "./pages/Admin";
import Privacy from "./pages/Privacy";

function AppContent() {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';

  return (
    <>
      {!isAdminPage && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/chi-siamo" element={<ChiSiamo />} />
        <Route path="/servizi" element={<Servizi />} />
        <Route path="/prodotti" element={<Prodotti />} />
        <Route path="/come-lavoriamo" element={<ComeLavoriamo />} />
        <Route path="/galleria" element={<Galleria />} />
        <Route path="/contatti" element={<Contatti />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      {!isAdminPage && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
}

export default App;
